import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ButtonLevel, ButtonType } from '@challenger6/vm-pattern-library/button';
import { Subscription, finalize } from 'rxjs';
import { NotificationType } from '@challenger6/vm-pattern-library/notification';
import { Upgrade360Content } from '../../models/upgrade-360-section.model';
import { ApiService } from '../../../common/services/api.service';

@Component({
  selector: 'vm-upgrade-360-section',
  templateUrl: './upgrade-360-section.component.html',
  styleUrls: ['./upgrade-360-section.component.scss'],
})
export class Upgrade360SectionComponent implements OnInit {
  @Input() data: Upgrade360Content;
  @Output() setAPILoadingState = new EventEmitter<boolean>();

  public form: FormGroup;
  buttonType = ButtonType;
  buttonLevel = ButtonLevel;
  showError: boolean;
  notificationMessage: string;
  findByDetailsSubscription: Subscription;
  nextSubscription: Subscription;
  type = NotificationType.WARNING;
  navigatorObj: any = navigator;
  postCodeSubscription: Subscription;

  constructor(private formBuilder: FormBuilder, private apiService: ApiService) {}

  ngOnInit(): void {
    this.setupForm();
  }

  setupForm(): void {
    this.form = this.formBuilder.group({
      firstName: ['', [Validators.required, Validators.pattern("[a-zA-Z ,.'-]*")]],
      surname: ['', [Validators.required, Validators.pattern("[a-zA-Z ,.'-]*")]],
      emailAddress: ['', [Validators.required, Validators.email]],
    });
  }

  submitForm(url) {
    this.setAPILoadingState.emit(true);
    this.form.markAllAsTouched();
    if (this.form?.valid) {
      this.apiService
        .order360Upgrade(
          this.form.get('firstName')?.value,
          this.form.get('surname')?.value,
          this.form.get('emailAddress')?.value
        )
        .pipe(
          finalize(() => {
            this.setAPILoadingState.emit(false);
          })
        )
        .subscribe(() => {
          this.setAPILoadingState.emit(false);
          window.location.href = url;
        });
    } else {
      this.setAPILoadingState.emit(false);
    }
  }
}
